<template>
  <!-- 選択肢用メッセージ -->
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <!-- 選択肢用メッセージ other -->
    <div class="message"
        :style="{
        'background' : speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
        'color'      : autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
        'filter'     : shadowStyle(color.shadowType)}">
        <p class="message-title" v-if="!isDemo||!isDemoEditScenario">{{ messageCreate(message) }}</p>
        <textarea
          class="textarea message-title"
          :value="originalMessage"
          @blur="oldValue = originalMessage; updateMainMessage($event.target.value, oldValue, logIndex)"
          v-else-if="!isConfirm">
        </textarea>
        <textarea
          disabled
          class="textarea message-title"
          :value="originalMessage"
          v-else>
        </textarea>
        <button
          v-for="(m, index) in message.replace('[card]', '').replace('[/card]', '').split('|')"
          :key="index"
          v-if="buttonCreate(m)!==''"
          class="button message-button"
          @click="pushButton(m, isBot, index - 1)"
          :class="['slide-button-'+String(index), {
            'is-info'        : colorCreate(m) === 'Blue',
            'is-warning'     : colorCreate(m) === 'Yellow',
            'is-danger'      : colorCreate(m) === 'Red'
          }]"
          :disabled="!isSubmitUrl&&isNowButton()">{{ buttonCreate(m) }}</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from "@/functions/hex2rgb"
// 外部関数
import {
  autoColor,
  shadowStyle,
  colorCreate,
  messageCreate,
  buttonCreate,
  isNowButton
} from "@/functions/balloonFunc"

export default {
  name: "SelectParts",
  props: ['message', 'speaker', 'color', 'lastIndex', 'logIndex', 'isBot', 'isDemo', 'isDemoEditScenario', 'scenarioID', 'isConfirm', 'roboArguments','isSubmitUrl'],
  data () {
    return {
        oldValue: ""
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable']),
    originalMessage () {
      return this.scenarioTable.find((obj) => {return this.scenarioID == obj.beforenode}).mainmessage
    }
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    colorCreate (m) {
      return colorCreate(m, this.roboArguments)
    },
    buttonCreate (m) {
      return buttonCreate(m, this.roboArguments)
    },
    messageCreate (m) {
      return messageCreate(m, this.roboArguments)
    },
    pushButton (m, isBot, btnIndex) {
      if (this.message.slice(0, 6) == "[card]" && this.message.slice(-7) == "[/card]") {
        this.$emit('pushButtonCard', m, isBot, btnIndex)
      } else {
        this.$emit('pushButton', m, isBot, btnIndex)
      }
    },
    updateMainMessage (value, oldValue, logIndex) {
      this.$emit('updateMainMessage', value, oldValue, logIndex)
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 12px 16px;  /* ①上下のpaddingを少し減らし、左右は維持 */
  width: auto;
  max-width: -webkit-fill-available;
  border-radius: 18px;  /* ②より丸みを持たせる */
  font-size: 95%;  /* ③fontsize up */
  line-height: 1.4;  /* ④読みやすさのために行間を調整 */
  transition: 0.7s;
  margin-bottom: 8px;  /* ⑤メッセージ間の間隔を追加 */
}
.message > .message-title {
  text-align: left;
  filter: none;
  font-size: 95%;  /* ③fontsize up */
  word-wrap: break-word;
  line-height: 1.4;  /* ④読みやすさのために行間を調整 */
  margin-bottom: 8px;
  white-space: pre-wrap;
}
.message > .message-button {
  display: flex; 
  justify-content: left;
  filter: none;
  min-width: 100%; max-width: 100%;
  margin-top: 8px;
  margin-bottom: 10px;
  height: auto;
  overflow: initial;
  white-space: normal;
  text-overflow: ellipsis;
  font-size: 95%;  /* ③fontsize up */
  line-height: 1.4;  /* ④読みやすさのために行間を調整 */
  text-align: left;
  border-radius: 18px;  /* ②より丸みを持たせる */
  margin-bottom: 8px;  /* ⑤メッセージ間の間隔を追加 */
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
.message-button {
  border: none;
  border-radius: 8px;
}
/* Animation */
@for $i from 0 through 10 {
  $enter-delay: 300ms;
  &.slide-button-#{$i} {
    // opacity: 1;
    animation-duration: #{200ms * ($i + 1)};
    animation-name: slide-in;
  }
}
@keyframes slide-in {
  0% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  70% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  100% {
    // opacity: 1;
    transform: scale(1) translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/SelectParts.vue